import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "fa"
    },
    theme: {
        themes: {
            light: {
                primary: "#2C439B"
            },
            dark: {
                primary: "#3b5bd4"
            }
        }
    }
});
